"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.messages = void 0;
exports.messages = {
    completedExaminations: {
        id: "dashboard.missing_examination",
        defaultMessage: "Elvégzett vizsgálatok"
    },
    missingExaminations: {
        id: "dashboard.missing_examinations",
        defaultMessage: "Nem elvégzett vizsgálatok"
    },
    abnormal: {
        id: "dashboard.abnormal",
        defaultMessage: "Eltérést mutat"
    },
    normal: {
        id: "dashboard.normal",
        defaultMessage: "Nincs eltérés"
    }
};
